<template>
    <div>
      <!-- <button class="btn btn-primary" @click="window.print()">Print</button> -->
      <div v-html="cardContent" class="print-area"></div>
    </div>
  </template>
  
  <script setup>
  alert('PrintIDCardPage');
  import { onMounted, ref, nextTick } from 'vue';
  
  const cardContent = ref('');
  
  onMounted(async () => {
    const rawData = sessionStorage.getItem('printData');
    // console.log('rawData', rawData);
    if (rawData) {
      // Optional: Clean invalid <style> blocks from API (like empty rules)
      const cleanedData = rawData.replace(/<style>[^<]*\.school-name[^<]*<\/style>/g, '');
      cardContent.value = cleanedData;
  
      await nextTick(); // Wait for DOM render
  
      // Attach click event to dynamically added button
      // const printBtn = document.querySelector('.btn.btn-primary');
      // if (printBtn) {
      //   printBtn.addEventListener('click', () => {
      //     window.print();
      //   });
      // }
    }
  });
  </script>
  
  <style scoped>
  @media print {
    .btn.btn-primary {
      display: none !important;
      
    }
  
    body {
      margin: 0;
      padding: 20px;
      font-family: Arial, sans-serif;
      background: white !important;
      color: black !important;
    }
  
    .print-area {
      display: block !important;
    }
  }
  </style>
  